<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    style="background-color: #262d4a; font-family: Montserrat"
    class="layout--main"
    :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]"
  >
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
        />

        <div id="builder-view" class="router-view">
          <vx-card class="digi__side-menu">
            <!-- <div v-for="(item, index) in sidebarItems" :key="index">
              <vs-button icon-pack="feather" :icon="item.icon" type="border" class="side-menu__button w-full">{{ item.name }}</vs-button>
            </div>-->
            <div v-for="(item, index) in sidebarItems" :key="index" class="w-full">
              <span class="side-menu__button pl-1 cursor-pointer flex" @click="navigate(item)">
                <!-- :class="[{'button-active': activeLink}]" -->
                <feather-icon :icon="item.icon" svg-classes="stroke-current mr-2 pr-2"></feather-icon>
                <p>{{ item.name }}</p>
              </span>
            </div>
          </vx-card>
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="30" v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg back-to-top_btn"
                />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import TheNavbar from "@/digicampus/components/DigiNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "../components/vx-sidebar/sidebarItems.js";
import BackToTop from "vue-backtotop";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "static",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      activeLink: false,
      to: "DigiCourseBuilder",
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.CheckIsActive();
    },
    isThemeDark(val) {
      if (val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
  },
  methods: {
    clickMethod() {
      this.$store.dispatch("updateTheme", "dark");
      this.$router.push({
        name: "DigiBackgrounds",
      });
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    navigate(item) {
      var self = this;
      self.to = item.slug;
      if (item.slug != "DigiCourseBuilder")
        self.$router.push({ name: item.slug });
      else {
        let routeData = self.$router.resolve({ name: "DigiCourseBuilder" });
        window.open(routeData.href, "_self");
        // self.$router.replace({ name: 'DigiCourseBuilder' });
      }
    },
    CheckIsActive() {
      // var self = this;
      // if (self.to) {
      //   if (self.$route.name == self.to)
      //     self.activeLink = true;
      //   else
      //     self.activeLink = false;
      // }
      // if (this.to) {
      //   if (
      //     this.$route.path.slice(1).includes(this.to.slice(1)) &&
      //     this.to.slice(1)
      //   )
      //     this.activeLink = true;
      //   else this.activeLink = false;
      // }
    },
    updateTheme() {
      this.$setColors();
    },
  },
  components: {
    TheNavbar,
    TheFooter,
    BackToTop,
  },
  created() {
    document.title = "DigiCampus";
    this.setSidebarWidth();
    if (this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }

    this.$setSchoolTheme();
    this.updateTheme();
  },
  updated() {
    this.CheckIsActive();
  },
};
</script>
<style lang="scss">
@import "../assets/FabStylesheet_1.scss";
@import "../assets/FabStylesheet_2.scss";
.vx-navbar-wrapper {
  background: none !important;
  padding: 2.2rem;
  padding-top: 1.3rem;
  z-index: 41000;
  height: 103px;
  position: relative;
  top: 0;
}
.vs-navbar.vx-navbar {
  background: linear-gradient(to bottom right, rgba(var(--vs-primary),1), rgba(var(--vs-secondary),1)) !important;
  padding: 0.8rem 1rem;
  width: calc(100% - 4.7rem);
  // width: calc(100% - 10.3rem);
  position: fixed;
  border-radius: 2.1rem;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  z-index: 10000;
}

#builder-view.router-view {
  // position: absolute !important;
  padding: 0 !important;
  padding-left: 2.2rem !important;
  top: 0 !important;
  width: calc(100% - 3.2rem);

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-left !important;
    text-align: -moz-left !important;
    margin-left: 250px !important;
  }
}

* {
  font-family: Montserrat;
}
</style>